module.exports = __webpack_public_path__ + "img/GNQ.3578cd8a.svg";